import { FONT_FACE_CSS, FONT_FAMILY } from '../source/shared/typography.js';

// plants.js
// Plants page logic only. Shared sidebar remains in script2.js.

function $(sel) {
  return document.querySelector(sel);
}

function createEl(tag, attrs = {}, children = []) {
  const el = document.createElement(tag);
  Object.entries(attrs).forEach(([k, v]) => {
    if (k === 'class') el.className = v;
    else if (k === 'text') el.textContent = v;
    else el.setAttribute(k, v);
  });
  (Array.isArray(children) ? children : [children])
    .filter(Boolean)
    .forEach((child) => el.appendChild(child));
  return el;
}

async function jsonFetch(url, options = {}) {
  const token = localStorage.getItem('lnf_token');
  const baseHeaders = { 'Content-Type': 'application/json' };
  if (token) baseHeaders.Authorization = 'Bearer ' + token;
  const opts = {
    headers: { ...baseHeaders, ...(options.headers || {}) },
    ...options
  };
  const res = await fetch(url, opts);
  if (!res.ok) {
    const text = await res.text();
    let message = text || `Request failed: ${res.status}`;
    try {
      const parsed = JSON.parse(text);
      if (parsed && typeof parsed === 'object') {
        message = parsed.error || parsed.message || message;
      }
    } catch (_err) {
      // fall back to raw text
    }
    throw new Error(message);
  }
  return res.status === 204 ? null : res.json();
}

function normalizeText(s) {
  if (!s) return '';
  let out = String(s);
  try {
    out = out.normalize('NFKD');
  } catch (_) {
    // older Safari versions may not support String.normalize; fall back silently
  }
  return out
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/\s+/g, ' ')
    .trim()
    .toLowerCase();
}

function escapeHtml(s) {
  return String(s || '').replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
}

function getField(obj, ...keys) {
  for (const k of keys) {
    if (obj && obj[k] !== undefined && obj[k] !== null && obj[k] !== '') return obj[k];
  }
  return '';
}

function debounce(fn, wait = 250) {
  let t = null;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

document.addEventListener('DOMContentLoaded', () => {
 // Plants page
const plantList = $('#plantList');
if (!plantList) return;
const statusEl = $('#plantStatus');
const contributeSection = $('#plantContribute');
const contributeForm = $('#plantContributeForm');
const contributeStatus = $('#plantContributeStatus');
const contributeSignIn = $('#plantContributeSignIn');
const contributeToggle = $('#toggleContribute');
const contributeBody = $('#contributeBody');
const contributeFields = {
  common: $('#contributeCommon'),
  latin: $('#contributeLatin'),
  family: $('#contributeFamily'),
  category: $('#contributeCategory'),
  lifecycle: $('#contributeLifecycle'),
  nativeRange: $('#contributeNativeRange'),
  height: $('#contributeHeight'),
  spread: $('#contributeSpread'),
  sun: $('#contributeSun'),
  soil: $('#contributeSoil'),
  water: $('#contributeWater'),
  hardiness: $('#contributeHardiness'),
  seedNotes: $('#contributeSeedNotes'),
  stratification: $('#contributeStratification'),
  propagation: $('#contributePropagation'),
  usesEdible: $('#contributeUsesEdible'),
  usesMedicinal: $('#contributeUsesMedicinal'),
  usesOther: $('#contributeUsesOther'),
  storageNotes: $('#contributeStorageNotes'),
  recipes: $('#contributeRecipes'),
  pollinators: $('#contributePollinators'),
  wildlife: $('#contributeWildlife'),
  nativeNotes: $('#contributeNativeNotes'),
  harvestNotes: $('#contributeHarvestNotes'),
  pruningNotes: $('#contributePruningNotes'),
  shortDesc: $('#contributeShortDesc'),
  funFacts: $('#contributeFunFacts')
};
const contributeImageInput = $('#contributeImage');
const contributeImagePreview = $('#contributeImagePreview');
let contributeImageData = null;
const waitlistModal = $('#waitlistModal');
const waitlistPlantField = $('#waitlistPlantField');
const waitlistTitle = $('#waitlistModalTitle');
const waitlistPrompt = $('#waitlistPrompt');
const waitlistCreateListing = $('#waitlistCreateListing');
const profileModal = $('#profilePreviewModal');
const profileNameEl = $('#profilePreviewName');
const profileTitleEl = $('#profilePreviewTitle');
const profileOccupationEl = $('#profilePreviewOccupation');
const profileRegionEl = $('#profilePreviewRegion');
const profileBioEl = $('#profilePreviewBio');
const profileStatusEl = $('#profilePreviewStatus');
const profileAvatarEl = $('#profilePreviewAvatar');
const profileCache = new Map();
const plantDetailCache = new Map();
let stockCache = null;
let stockFetchPromise = null;
const reviewMessage = 'This plant was recently submitted and is still being reviewed for accuracy.';
// Modal elements for plant details
const modalBackdrop = $('#plantModal');
const modalContent = $('#plantModalContent');
const modalCloseBtn = modalBackdrop ? modalBackdrop.querySelector('.modal-close') : null;

const setSignInPrompt = (el, label) => {
  if (!el) return;
  el.innerHTML = `Please sign in to submit a ${label}. <a href="profile.html">Sign in</a>`;
};

const sanitizeMediaSrc = (value) => {
  const raw = String(value || '').trim();
  if (!raw) return '';
  if (/^data:image\/[a-z0-9.+-]+;base64,/i.test(raw)) return raw;
  if (/^blob:/i.test(raw)) return raw;
  try {
    const parsed = new URL(raw, window.location.origin);
    if (parsed.protocol === 'http:' || parsed.protocol === 'https:') return parsed.toString();
  } catch (_err) {
    // ignore invalid URLs
  }
  return '';
};

const normalizeImageArray = (rawValue) => {
  if (Array.isArray(rawValue)) {
    return rawValue
      .filter((value) => typeof value === 'string')
      .map((value) => value.trim())
      .filter(Boolean);
  }
  if (typeof rawValue === 'string') {
    const trimmed = rawValue.trim();
    if (!trimmed) return [];
    if (trimmed.startsWith('[') && trimmed.endsWith(']')) {
      try {
        const parsed = JSON.parse(trimmed);
        if (Array.isArray(parsed)) {
          return parsed
            .filter((value) => typeof value === 'string')
            .map((value) => value.trim())
            .filter(Boolean);
        }
      } catch (_err) {
        return [];
      }
    }
  }
  return [];
};

const initialFor = (name) => {
  const first = (name || '').trim().charAt(0);
  return first ? first.toUpperCase() : 'U';
};

const renderAvatarEl = (el, src, name = '') => {
  if (!el) return;
  el.textContent = '';
  const safeSrc = sanitizeMediaSrc(src);
  if (safeSrc) {
    const image = createEl('img', {
      src: safeSrc,
      alt: name ? `${String(name).trim()} profile` : 'Profile photo'
    });
    el.appendChild(image);
    return;
  }
  el.appendChild(createEl('span', { class: 'avatar-fallback', text: initialFor(name) }));
};

const fetchPublicProfile = async (userId) => {
  if (!userId) throw new Error('Missing user id');
  const key = String(userId);
  if (profileCache.has(key)) return profileCache.get(key);
  const profile = await jsonFetch(`/api/public-profiles/${encodeURIComponent(key)}`);
  profileCache.set(key, profile);
  return profile;
};

const buildPlantDataFromRecord = (record, fallback = {}) => {
  const source = record || {};
  const base = fallback || {};
  const value = (key) => source[key] ?? base[key] ?? null;
  const imageUrls = normalizeImageArray(value('image_urls'));
  return {
    id: value('id'),
    common: value('common_name'),
    latin: value('latin_name'),
    family: value('family'),
    category: value('category'),
    lifecycle: value('lifecycle'),
    image_urls: imageUrls,
    image: imageUrls[0] || null,
    nativeRange: value('native_range'),
    height: value('height'),
    spread: value('spread'),
    sun: value('sun'),
    soil: value('soil'),
    water: value('water'),
    hardiness: value('hardiness'),
    seedNotes: value('seed_notes'),
    strat: value('stratification'),
    propagation: value('propagation_methods'),
    usesEdible: value('uses_edible'),
    usesMedicinal: value('uses_medicinal'),
    usesOther: value('uses_other'),
    storageNotes: value('storage_notes'),
    recipes: value('recipes'),
    pollinators: value('pollinators'),
    wildlife: value('wildlife_value'),
    nativeNotes: value('native_notes'),
    harvestNotes: value('harvest_notes'),
    pruningNotes: value('pruning_notes'),
    shortDesc: value('short_desc'),
    funFacts: value('fun_facts'),
    review_status: value('review_status'),
    stock: getAvailableStockCount(source)
  };
};

const fetchPlantDetail = async (plantId) => {
  const key = String(plantId || '').trim();
  if (!key) return null;
  if (plantDetailCache.has(key)) return plantDetailCache.get(key);
  const params = new URLSearchParams({ plant_id: key, detail: '1' });
  const rows = await jsonFetch(`/api/plants?${params.toString()}`);
  const detail = Array.isArray(rows) ? (rows[0] || null) : null;
  if (detail) plantDetailCache.set(key, detail);
  return detail;
};

const clearProfilePreview = (fallbackName = 'Community member') => {
  if (profileNameEl) profileNameEl.textContent = fallbackName;
  if (profileTitleEl) profileTitleEl.textContent = fallbackName;
  if (profileOccupationEl) profileOccupationEl.textContent = '   ';
  if (profileRegionEl) profileRegionEl.textContent = '   ';
  if (profileBioEl) profileBioEl.textContent = 'No bio provided.';
  if (profileStatusEl) profileStatusEl.textContent = '';
  renderAvatarEl(profileAvatarEl, null, fallbackName);
};

const openProfilePreview = async (userId, fallbackName = 'Community member') => {
  if (!profileModal || !userId) return;
  clearProfilePreview(fallbackName);
  if (profileStatusEl) profileStatusEl.textContent = 'Loading profile...';
  profileModal.classList.remove('is-hidden');
  try {
    const profile = await fetchPublicProfile(userId);
    const name = profile.display_name || fallbackName;
    if (profileNameEl) profileNameEl.textContent = name;
    if (profileTitleEl) profileTitleEl.textContent = name || 'Public Profile';
    if (profileOccupationEl) profileOccupationEl.textContent = profile.occupation || '   ';
    if (profileRegionEl) profileRegionEl.textContent = profile.region || '   ';
    if (profileBioEl) profileBioEl.textContent = profile.bio || 'No bio provided.';
    renderAvatarEl(profileAvatarEl, profile.avatar_url || null, name);
    if (profileStatusEl) profileStatusEl.textContent = '';
  } catch (err) {
    console.error('public profile load error:', err);
    if (profileStatusEl) profileStatusEl.textContent = 'Could not load profile.';
  }
};

function closeWaitlistModal() {
  if (!waitlistModal) return;
  waitlistModal.classList.remove('is-visible');
  waitlistModal.setAttribute('aria-hidden', 'true');
}

function openWaitlistModal(plantName) {
  if (!waitlistModal) return;
  const safeName = plantName || '';
  if (waitlistPlantField) waitlistPlantField.value = plantName || '';
  if (waitlistTitle) waitlistTitle.textContent = plantName ? `Make a Lost listing for ${plantName}` : 'Make a Lost listing';
  if (waitlistPrompt) {
    const label = safeName ? `Sorry we dont have those in stock yet! Would you like to make a listing looking for ${safeName}?` : 'Sorry we dont have those in stock yet! Would you like to make a listing looking for this plant?';
    waitlistPrompt.textContent = label;
  }
  if (waitlistCreateListing) {
    waitlistCreateListing.disabled = !safeName;
    waitlistCreateListing.dataset.plantName = safeName;
  }
  waitlistModal.classList.add('is-visible');
  waitlistModal.setAttribute('aria-hidden', 'false');
  if (waitlistCreateListing) waitlistCreateListing.focus();
}

async function fetchStockData() {
  if (stockCache) return stockCache;
  if (!stockFetchPromise) {
    stockFetchPromise = jsonFetch('/api/stock/current').catch((err) => {
      console.warn('Stock lookup failed', err);
      return [];
    });
  }
  stockCache = await stockFetchPromise;
  return stockCache || [];
}

function toStockCount(value) {
  const num = Number(value);
  if (!Number.isFinite(num) || num <= 0) return 0;
  return Math.round(num);
}

function getAvailableStockCount(item) {
  const formEntries = Array.isArray(item?.form_entries)
    ? item.form_entries
    : [];
  if (formEntries.length) {
    return formEntries.reduce((sum, entry) => (
      sum + toStockCount(entry?.stock_left)
    ), 0);
  }
  return toStockCount(getField(item, 'stock_left'));
}

function getPlantStockLookupName(plantInput) {
  const source = typeof plantInput === 'string'
    ? { common_name: plantInput }
    : (plantInput || {});
  return String(getField(source, 'common_name', 'commonName', 'common') || '').trim();
}

function compactLookupText(value) {
  return normalizeText(value).replace(/[^a-z0-9]+/g, '');
}

function tokenizeLookupText(value) {
  return normalizeText(value)
    .replace(/[^a-z0-9]+/g, ' ')
    .split(' ')
    .filter((token) => token.length > 1);
}

function stockItemMatchesPlantName(item, plantName = '') {
  const rawItemName = String(getField(item, 'item', 'name') || '').trim();
  const normalizedPlantName = normalizeText(plantName);
  const normalizedItemName = normalizeText(rawItemName);
  if (!normalizedPlantName || !normalizedItemName) return false;
  if (normalizedPlantName === normalizedItemName) return true;

  const compactPlantName = compactLookupText(plantName);
  const compactItemName = compactLookupText(rawItemName);
  if (compactPlantName && compactItemName) {
    if (compactItemName.includes(compactPlantName) || compactPlantName.includes(compactItemName)) {
      return true;
    }
  }

  const plantTokens = tokenizeLookupText(plantName);
  const itemTokens = tokenizeLookupText(rawItemName);
  if (!plantTokens.length || !itemTokens.length) return false;

  const overlapCount = plantTokens.filter((token) => (
    itemTokens.some((itemToken) => (
      itemToken === token || itemToken.includes(token) || token.includes(itemToken)
    ))
  )).length;

  if (plantTokens.length === 1) return overlapCount === 1;
  if (overlapCount === plantTokens.length) return true;
  return overlapCount >= Math.max(2, plantTokens.length - 1);
}

async function handleStockCheck(plantInput) {
  const primaryName = getPlantStockLookupName(plantInput);
  if (!primaryName) {
    await window.lnfUi.alert({
      title: 'Stock lookup',
      message: 'Plant name missing for stock lookup.'
    });
    return;
  }
  try {
    const stock = await fetchStockData();
    const hasAvailableMatch = stock.some((item) => (
      stockItemMatchesPlantName(item, primaryName) && getAvailableStockCount(item) > 0
    ));
    if (hasAvailableMatch) {
      const url = new URL('stock-register.html', window.location.href);
      url.searchParams.set('focus', '1');
      url.searchParams.set('item', primaryName);
      window.location.href = url.toString();
      return;
    }
    openWaitlistModal(primaryName);
  } catch (err) {
    console.error('handleStockCheck error', err);
    openWaitlistModal(primaryName);
  }
}

function setContributeVisible(show) {
  if (!contributeBody || !contributeToggle) return;
  contributeBody.style.display = show ? '' : 'none';
  contributeToggle.textContent = show ? 'Hide Form' : 'Add Plants';
}

function closePlantModal() {
    if (!modalBackdrop) return;
    modalBackdrop.classList.remove('is-visible');
    modalBackdrop.setAttribute('aria-hidden', 'true');
    if (modalContent) modalContent.innerHTML = '';
}

function buildPlantCommentsSection(plantData, mode = 'lost') {
  const resolvedMode = mode === 'found' ? 'found' : 'lost';
  const section = createEl('div', { class: 'plant-comments', 'data-mode': resolvedMode });
  section.appendChild(createEl('h3', { text: 'Comments' }));
  section.appendChild(createEl('p', { class: 'muted small', text: 'Share use notes, grow tips, and community observations for this plant.' }));

  const listWrap = createEl('div', { class: 'plant-comment-columns' });
  const status = createEl('p', { class: 'muted small', text: '' });
  section.appendChild(listWrap);
  section.appendChild(status);

  const signedIn = Boolean(localStorage.getItem('lnf_token'));
  if (!signedIn) setSignInPrompt(status, 'comment');

  const makeColumn = (title, categoryKey, emptyLabel) => {
    const column = createEl('div', { class: 'plant-comment-column' });
    column.appendChild(createEl('h4', { text: title }));
    const list = createEl('div', { class: 'plant-comment-list' });
    const form = createEl('form', { class: 'plant-comment-form' });
    const textarea = createEl('textarea', { rows: '3', placeholder: `Add ${title.toLowerCase()}...` });
    const submit = createEl('button', { class: 'button', type: 'submit', text: 'Post comment' });

    form.appendChild(textarea);
    form.appendChild(submit);
    column.appendChild(list);
    column.appendChild(form);

    if (!signedIn) {
      textarea.disabled = true;
      submit.disabled = true;
    }

    const renderItems = (items) => {
      list.innerHTML = '';
      if (!items.length) {
        list.appendChild(createEl('p', { class: 'muted small', text: emptyLabel }));
        return;
      }
      items.forEach((item) => {
      const card = createEl('article', { class: 'plant-comment-card' });
      const meta = createEl('div', { class: 'plant-comment-meta' });
      const authorName = item.display_name || item.author_name || 'Community member';
      const authorId = item.author_id || null;
      const authorAvatar = item.avatar_url || null;
      const authorWrap = createEl('div', { class: 'plant-comment-author' });
      const avatar = createEl('div', { class: 'avatar avatar--sm', 'aria-hidden': 'true' });
      renderAvatarEl(avatar, authorAvatar, authorName);
      authorWrap.appendChild(avatar);
      if (authorId) {
        const authorLink = createEl('button', { type: 'button', class: 'profile-link plant-comment-author-name', text: authorName });
        authorLink.addEventListener('click', () => openProfilePreview(authorId, authorName));
        authorWrap.appendChild(authorLink);
      } else {
        authorWrap.appendChild(createEl('span', { class: 'plant-comment-author-name', text: authorName }));
      }
      const ts = item.created_at || null;
      const timeLabel = ts ? new Date(ts).toLocaleString() : 'just now';
      meta.appendChild(authorWrap);
      meta.appendChild(createEl('span', { text: '   ' }));
      meta.appendChild(createEl('span', { text: timeLabel }));
      card.appendChild(meta);
      card.appendChild(createEl('p', { text: item.body || '' }));
      list.appendChild(card);
      });
    };

    form.addEventListener('submit', async (e) => {
      e.preventDefault();
      if (!signedIn) {
        setSignInPrompt(status, 'comment');
        window.lnfAuthGate?.show?.();
        return;
      }
      if (!plantData.id) {
        status.textContent = 'Comments are unavailable for this plant.';
        return;
      }
      const body = (textarea.value || '').trim();
      if (!body) {
        status.textContent = 'Please add a comment.';
        return;
      }
      window.lnfNotifications?.maybePrompt?.({ reason: 'plant-comment' });
      status.textContent = 'Posting...';
      try {
        await jsonFetch(`/api/plants/${plantData.id}/comments`, {
          method: 'POST',
          body: JSON.stringify({ body, category: categoryKey })
        });
        textarea.value = '';
        status.textContent = 'Comment posted.';
        await loadComments();
      } catch (err) {
        console.error('plant comment post error', err);
        status.textContent = 'Failed to post comment.';
      }
    });

    listWrap.appendChild(column);
    return { categoryKey, renderItems };
  };

  const columnDefs = [
    { title: 'Use Comments', key: 'use', empty: 'No use comments yet. Add one!', show: resolvedMode === 'found' },
    { title: 'Grow Comments', key: 'grow', empty: 'No grow comments yet. Add one!', show: resolvedMode === 'lost' },
    { title: 'Community Comments', key: 'community', empty: 'No community comments yet. Add one!', show: true }
  ];

  const columns = columnDefs
    .filter((def) => def.show)
    .map((def) => makeColumn(def.title, def.key, def.empty));

  const normalizeCategory = (value) => {
    const raw = (value || '').toLowerCase().trim();
    if (['use', 'uses', 'recipe', 'recipes', 'edible'].includes(raw)) return 'use';
    if (['grow', 'growing', 'growth', 'propagation'].includes(raw)) return 'grow';
    if (['community', 'fun', 'general', 'misc'].includes(raw)) return 'community';
    return 'community';
  };

  const loadComments = async () => {
    if (!plantData.id) {
      status.textContent = 'Comments are unavailable for this plant.';
      return;
    }
    status.textContent = 'Loading comments...';
    try {
      const items = await jsonFetch(`/api/plants/${plantData.id}/comments?limit=200`);
      status.textContent = '';
      const safeItems = Array.isArray(items) ? items : [];
      columns.forEach((col) => {
        const grouped = safeItems.filter((item) => normalizeCategory(item.category) === col.categoryKey);
        col.renderItems(grouped);
      });
    } catch (err) {
      console.error('plant comment load error', err);
      status.textContent = 'Could not load comments right now.';
    }
  };

  loadComments();
  return section;
}

function openPlantModal(data) {
  if (!modalBackdrop || !modalContent) return;

  modalContent.innerHTML = '';

  const dossier = createEl('div', { class: 'plant-dossier' });

  const titleText = data.common || data.latin || 'Unnamed plant';

  // Header block (image + quick facts)
  const header = createEl('div', { class: 'dossier-header' });
  if (data.image) {
    header.appendChild(
      createEl('div', { class: 'dossier-image' }, [
        createEl('img', {
          src: data.image,
          alt: data.common || data.latin || 'Plant image',
          loading: 'lazy',
          decoding: 'async'
        })
      ])
    );
  }

  const headingCol = createEl('div', { class: 'dossier-headings' });
  headingCol.appendChild(createEl('h2', { id: 'plantModalTitle', text: titleText }));

  if (data.latin && data.latin !== titleText) {
    headingCol.appendChild(
      createEl('div', { class: 'latin-name muted' }, [
        createEl('em', { text: data.latin })
      ])
    );
  }

  const metaLine = createEl('div', { class: 'dossier-meta-line muted small' });
  if (data.family) metaLine.appendChild(createEl('span', { text: `Family: ${data.family}` }));
  if (metaLine.childNodes.length) headingCol.appendChild(metaLine);

  header.appendChild(headingCol);
  dossier.appendChild(header);

  const modeSwitch = createEl('div', { class: 'plant-mode-switch' });
  modeSwitch.appendChild(createEl('p', { class: 'mode-question', text: 'Do you have this plant yet?' }));
  const modeButtons = createEl('div', { class: 'mode-buttons', role: 'group', 'aria-label': 'Plant intent' });
  const lostBtn = createEl('button', { class: 'intent-btn intent-btn--compact', type: 'button' });
  lostBtn.appendChild(createEl('span', { class: 'intent-main', text: 'Lost' }));
  lostBtn.appendChild(createEl('span', { class: 'intent-sub', text: '(No)' }));
  const foundBtn = createEl('button', { class: 'intent-btn intent-btn--compact', type: 'button' });
  foundBtn.appendChild(createEl('span', { class: 'intent-main', text: 'Found' }));
  foundBtn.appendChild(createEl('span', { class: 'intent-sub', text: '(Yes)' }));
  modeButtons.appendChild(lostBtn);
  modeButtons.appendChild(foundBtn);
  modeSwitch.appendChild(modeButtons);
  modeSwitch.appendChild(
    createEl('div', { class: 'mode-descriptor muted small' }, [
      createEl('span', { text: "Lost=I don't have this plant yet and want to grow it." }),
      createEl('span', { text: 'Found=I have this plant and want to use it.' })
    ])
  );

  const addSection = (target, title, items) => {
    const contentItems = items.filter(Boolean);
    if (!contentItems.length) return;
    const section = createEl('div', { class: 'dossier-section' });
    section.appendChild(createEl('h3', { text: title }));
    contentItems.forEach((text) => {
      section.appendChild(createEl('p', { class: 'muted', text }));
    });
    target.appendChild(section);
  };

  const addFactGrid = (target, entries) => {
    const factEntries = entries.filter((f) => f.value);
    if (!factEntries.length) return;
    const factGrid = createEl('div', { class: 'dossier-grid' });
    factEntries.forEach((item) => {
      factGrid.appendChild(
        createEl('div', { class: 'fact-card' }, [
          createEl('div', { class: 'fact-label', text: item.label }),
          createEl('div', { class: 'fact-value', text: item.value })
        ])
      );
    });
    target.appendChild(factGrid);
  };

  const sharedBlock = createEl('div', { class: 'dossier-shared' });
  addFactGrid(sharedBlock, [
    { label: 'Category', value: data.category },
    { label: 'Sun', value: data.sun },
    { label: 'Soil', value: data.soil },
    { label: 'Water', value: data.water }
  ]);
  addSection(sharedBlock, 'Short description', [
    data.shortDesc && `${data.shortDesc}`
  ]);
  if (data.funFacts) {
    sharedBlock.appendChild(
      createEl('div', { class: 'dossier-section funfacts' }, [
        createEl('h3', { text: 'Fun fact' }),
        createEl('p', { text: data.funFacts })
      ])
    );
  }

  const lostBlock = createEl('div', { class: 'dossier-mode', 'data-mode': 'lost' });
  addFactGrid(lostBlock, [
    { label: 'Lifecycle', value: data.lifecycle },
    { label: 'Height', value: data.height },
    { label: 'Spread', value: data.spread },
    { label: 'Sun', value: data.sun },
    { label: 'Soil', value: data.soil },
    { label: 'Water', value: data.water },
    { label: 'Native range', value: data.nativeRange },
    { label: 'Hardiness', value: data.hardiness }
  ]);
  addSection(lostBlock, 'Propagation', [
    data.seedNotes && `Seed notes: ${data.seedNotes}`,
    data.strat && `Stratification: ${data.strat}`,
    data.propagation && `Propagation: ${data.propagation}`
  ]);
  addSection(lostBlock, 'Native notes', [
    data.nativeNotes && `${data.nativeNotes}`
  ]);
  addSection(lostBlock, 'Pruning notes', [
    data.pruningNotes && `${data.pruningNotes}`
  ]);
  lostBlock.appendChild(buildPlantCommentsSection(data, 'lost'));

  const foundBlock = createEl('div', { class: 'dossier-mode', 'data-mode': 'found' });
  addSection(foundBlock, 'Uses & value', [
    data.usesEdible && `Edible uses: ${data.usesEdible}`,
    data.usesMedicinal && `Medicinal uses: ${data.usesMedicinal}`,
    data.usesOther && `Other uses: ${data.usesOther}`
  ]);
  addSection(foundBlock, 'Wildlife & pollinators', [
    data.wildlife && `Wildlife: ${data.wildlife}`,
    data.pollinators && `Pollinators: ${data.pollinators}`
  ]);
  addSection(foundBlock, 'Harvest notes', [
    data.harvestNotes && `${data.harvestNotes}`
  ]);
  addSection(foundBlock, 'Storage notes', [
    data.storageNotes && `${data.storageNotes}`
  ]);
  addSection(foundBlock, 'Recipes', [
    data.recipes && `${data.recipes}`
  ]);
  foundBlock.appendChild(buildPlantCommentsSection(data, 'found'));

  dossier.appendChild(sharedBlock);
  dossier.appendChild(modeSwitch);
  dossier.appendChild(lostBlock);
  dossier.appendChild(foundBlock);

  // Suggest an edit
  const suggest = createEl('div', { class: 'suggest-form' });
  suggest.appendChild(createEl('h3', { text: 'Suggest an edit' }));
  suggest.appendChild(createEl('p', { class: 'muted small', text: 'Spot an error or want to add more detail? Share it here and an admin will review.' }));
  const fieldLabel = createEl('label', { class: 'muted small', for: 'plantSuggestField', text: 'What would you like to change on this dossier?' });
  const fieldSelect = createEl('select', { id: 'plantSuggestField' });
  [
    { value: '', label: 'Select a field' },
    { value: 'Common name', label: 'Common name' },
    { value: 'Latin name', label: 'Latin name' },
    { value: 'Family', label: 'Family' },
    { value: 'Category', label: 'Category' },
    { value: 'Lifecycle', label: 'Lifecycle' },
    { value: 'Native range', label: 'Native range' },
    { value: 'Height', label: 'Height' },
    { value: 'Spread', label: 'Spread' },
    { value: 'Sun', label: 'Sun' },
    { value: 'Soil', label: 'Soil' },
    { value: 'Water', label: 'Water' },
    { value: 'Hardiness', label: 'Hardiness' },
    { value: 'Seed notes', label: 'Seed notes' },
    { value: 'Stratification', label: 'Stratification' },
    { value: 'Propagation', label: 'Propagation' },
    { value: 'Edible uses', label: 'Edible uses' },
    { value: 'Medicinal uses', label: 'Medicinal uses' },
    { value: 'Other uses', label: 'Other uses' },
    { value: 'Storage notes', label: 'Storage notes' },
    { value: 'Recipes', label: 'Recipes' },
    { value: 'Pollinators', label: 'Pollinators' },
    { value: 'Wildlife', label: 'Wildlife' },
    { value: 'Native notes', label: 'Native notes' },
    { value: 'Harvest notes', label: 'Harvest notes' },
    { value: 'Pruning notes', label: 'Pruning notes' },
    { value: 'Short description', label: 'Short description' },
    { value: 'Fun facts', label: 'Fun facts' },
    { value: 'Images', label: 'Images' },
    { value: 'General / other', label: 'General / other' }
  ].forEach((opt, idx) => {
    const optionEl = createEl('option', { value: opt.value, text: opt.label });
    if (idx === 0) optionEl.disabled = true;
    if (idx === 0) optionEl.selected = true;
    fieldSelect.appendChild(optionEl);
  });
  const textarea = createEl('textarea', { id: 'plantSuggestText', placeholder: 'Describe the change you want to make...' });
  const status = createEl('p', { class: 'muted small', id: 'plantSuggestStatus', text: '' });
  const submit = createEl('button', { class: 'button', type: 'button', text: 'Send suggestion' });
  suggest.appendChild(fieldLabel);
  suggest.appendChild(fieldSelect);
  suggest.appendChild(textarea);
  suggest.appendChild(status);
  suggest.appendChild(submit);

  const signedIn = Boolean(localStorage.getItem('lnf_token'));
  if (!signedIn) {
    textarea.disabled = true;
    fieldSelect.disabled = true;
    submit.disabled = true;
    status.textContent = 'Sign in to suggest edits.';
  }

  submit.addEventListener('click', async () => {
    if (!signedIn) {
      status.textContent = 'Sign in to suggest edits.';
      window.lnfAuthGate?.show?.();
      return;
    }
    const note = (textarea.value || '').trim();
    const field = (fieldSelect.value || '').trim();
    if (!field) {
      status.textContent = 'Please choose a field before sending.';
      return;
    }
    if (!note) {
      status.textContent = 'Please add a note before sending.';
      return;
    }
    window.lnfNotifications?.maybePrompt?.({ reason: 'plant-suggestion' });
    status.textContent = 'Sending...';
    if (!data.id) {
      status.textContent = 'Suggestions are unavailable for this plant right now.';
      return;
    }
    try {
      const plantName = data.common || data.latin || 'Unnamed';
      const noteWithField = `Field: ${field}\n${note}`;
      await jsonFetch(`/api/plants/${data.id}/suggestions`, {
        method: 'POST',
        body: JSON.stringify({ note: noteWithField, plant_name: plantName })
      });
      status.textContent = 'Thanks! Your suggestion was sent to the admins.';
      fieldSelect.selectedIndex = 0;
      textarea.value = '';
    } catch (err) {
      console.error('suggest edit error', err);
      if (String(err.message || '').includes('401')) {
        status.textContent = 'Please sign in again to send suggestions.';
        window.lnfAuthGate?.show?.();
        return;
      }
      status.textContent = 'Could not send right now. Please try again.';
    }
  });

  dossier.appendChild(suggest);

  modalContent.appendChild(dossier);

  modalBackdrop.classList.add('is-visible');
  modalBackdrop.setAttribute('aria-hidden', 'false');

  const setMode = (mode) => {
    const resolved = mode === 'found' ? 'found' : mode === 'lost' ? 'lost' : 'basic';
    const isFound = resolved === 'found';
    const isLost = resolved === 'lost';
    const isBasic = resolved === 'basic';
    modeSwitch.classList.toggle('is-compact', !isBasic);
    lostBtn.classList.toggle('is-active', isLost);
    foundBtn.classList.toggle('is-active', isFound);
    lostBtn.classList.toggle('is-inactive', !isLost && !isBasic);
    foundBtn.classList.toggle('is-inactive', !isFound && !isBasic);
    lostBtn.setAttribute('aria-pressed', String(isLost));
    foundBtn.setAttribute('aria-pressed', String(isFound));
    sharedBlock.style.display = '';
    lostBlock.style.display = isLost ? '' : 'none';
    foundBlock.style.display = isFound ? '' : 'none';
    sharedBlock.setAttribute('aria-hidden', 'false');
    lostBlock.setAttribute('aria-hidden', isLost ? 'false' : 'true');
    foundBlock.setAttribute('aria-hidden', isFound ? 'false' : 'true');
  };

  lostBtn.addEventListener('click', () => setMode('lost'));
  foundBtn.addEventListener('click', () => setMode('found'));
  setMode('basic');
}

async function openPlantModalWithDetail(baseData) {
  if (!baseData) return;
  openPlantModal(baseData);
  const plantId = baseData.id;
  if (!plantId) return;
  try {
    const detail = await fetchPlantDetail(plantId);
    if (!detail || !modalBackdrop || !modalBackdrop.classList.contains('is-visible')) return;
    const merged = buildPlantDataFromRecord(detail, baseData);
    openPlantModal(merged);
  } catch (err) {
    console.error('plant detail load error', err);
  }
}

// Close modal interactions
if (modalBackdrop) {
    modalBackdrop.addEventListener('click', (e) => {
        if (e.target === modalBackdrop) closePlantModal();
    });
}
if (modalCloseBtn) {
    modalCloseBtn.addEventListener('click', closePlantModal);
}
if (waitlistModal) {
  waitlistModal.addEventListener('click', (e) => {
    if (e.target === waitlistModal) closeWaitlistModal();
  });
  const waitlistCloses = waitlistModal.querySelectorAll('.modal-close, [data-close-waitlist]');
  waitlistCloses.forEach((btn) => btn.addEventListener('click', closeWaitlistModal));
}

waitlistCreateListing?.addEventListener('click', () => {
  const plantName = waitlistCreateListing.dataset.plantName || waitlistPlantField?.value || '';
  if (!plantName) return;
  const url = new URL('trade-space.html', window.location.href);
  url.searchParams.set('intent', 'lost');
  url.searchParams.set('title', plantName);
  url.searchParams.set('category', 'Plants');
  window.location.href = url.toString();
});
document.body.addEventListener('click', (evt) => {
  const closeTarget = evt.target.closest('[data-close-modal]');
  if (closeTarget) {
    const id = closeTarget.dataset.closeModal;
    const modal = document.getElementById(id);
    if (modal) modal.classList.add('is-hidden');
  }
});
document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') {
    closePlantModal();
    closeWaitlistModal();
    if (profileModal) profileModal.classList.add('is-hidden');
  }
});

  const isSignedIn = Boolean(localStorage.getItem('lnf_token'));
  if (contributeSection) {
    if (!isSignedIn) {
      if (contributeForm) contributeForm.style.display = 'none';
      if (contributeSignIn) {
        contributeSignIn.innerHTML = 'Please sign in to submit a plant. <a href="profile.html">Sign in</a>';
        contributeSignIn.style.display = '';
      }
    } else {
      if (contributeForm) contributeForm.style.display = '';
      if (contributeSignIn) contributeSignIn.style.display = 'none';
    }
  }

  if (contributeToggle) {
    setContributeVisible(false);
    contributeToggle.addEventListener('click', () => {
      const showing = contributeBody && contributeBody.style.display !== 'none';
      setContributeVisible(!showing);
    });
  }

  if (contributeForm) {
    contributeForm.addEventListener('submit', async (e) => {
      e.preventDefault();
      if (!contributeFields.common) return;
      if (!isSignedIn) {
        if (contributeStatus) {
          contributeStatus.innerHTML = 'Please sign in to submit a plant. <a href="profile.html">Sign in</a>';
        }
        window.lnfAuthGate?.show?.();
        return;
      }
      const payload = {
        common_name: (contributeFields.common.value || '').trim(),
        latin_name: (contributeFields.latin?.value || '').trim() || null,
        family: (contributeFields.family?.value || '').trim() || null,
        category: (contributeFields.category?.value || '').trim() || null,
        lifecycle: (contributeFields.lifecycle?.value || '').trim() || null,
        native_range: (contributeFields.nativeRange?.value || '').trim() || null,
        height: (contributeFields.height?.value || '').trim() || null,
        spread: (contributeFields.spread?.value || '').trim() || null,
        sun: (contributeFields.sun?.value || '').trim() || null,
        soil: (contributeFields.soil?.value || '').trim() || null,
        water: (contributeFields.water?.value || '').trim() || null,
        hardiness: (contributeFields.hardiness?.value || '').trim() || null,
        seed_notes: (contributeFields.seedNotes?.value || '').trim() || null,
        stratification: (contributeFields.stratification?.value || '').trim() || null,
        propagation_methods: (contributeFields.propagation?.value || '').trim() || null,
        uses_edible: (contributeFields.usesEdible?.value || '').trim() || null,
        uses_medicinal: (contributeFields.usesMedicinal?.value || '').trim() || null,
        uses_other: (contributeFields.usesOther?.value || '').trim() || null,
        storage_notes: (contributeFields.storageNotes?.value || '').trim() || null,
        recipes: (contributeFields.recipes?.value || '').trim() || null,
        pollinators: (contributeFields.pollinators?.value || '').trim() || null,
        wildlife_value: (contributeFields.wildlife?.value || '').trim() || null,
        native_notes: (contributeFields.nativeNotes?.value || '').trim() || null,
        harvest_notes: (contributeFields.harvestNotes?.value || '').trim() || null,
        pruning_notes: (contributeFields.pruningNotes?.value || '').trim() || null,
        short_desc: (contributeFields.shortDesc?.value || '').trim() || null,
        fun_facts: (contributeFields.funFacts?.value || '').trim() || null,
        image_urls: contributeImageData ? [contributeImageData] : null
      };
      if (!payload.common_name) {
        if (contributeStatus) contributeStatus.textContent = 'Common name is required.';
        return;
      }
      window.lnfNotifications?.maybePrompt?.({ reason: 'plant-contribute' });
      try {
        if (contributeStatus) contributeStatus.textContent = 'Submitting...';
        await jsonFetch('/api/plants', { method: 'POST', body: JSON.stringify(payload) });
        if (contributeStatus) contributeStatus.textContent = 'Submitted! Marked Under Review until an admin confirms it.';
        contributeForm.reset();
        contributeImageData = null;
        if (contributeImagePreview) contributeImagePreview.innerHTML = '';
        setTimeout(() => window.location.reload(), 500);
      } catch (err) {
        console.error('Contribute plant error', err);
        if (contributeStatus) contributeStatus.textContent = 'Could not submit right now.';
      }
    });
  }

  // Waitlist form removed in favor of quick "Lost listing" flow.

  if (contributeImageInput) {
    contributeImageInput.addEventListener('change', () => {
      const file = contributeImageInput.files && contributeImageInput.files[0];
      contributeImageData = null;
      if (!file) {
        if (contributeImagePreview) contributeImagePreview.innerHTML = '';
        return;
      }
      const reader = new FileReader();
      reader.onload = () => {
        contributeImageData = reader.result;
        if (contributeImagePreview) {
          contributeImagePreview.innerHTML = `<img src="${reader.result}" alt="Preview" class="upload-preview__img">`;
        }
      };
      reader.onerror = () => {
        if (contributeStatus) contributeStatus.textContent = 'Could not read image file.';
        contributeImageInput.value = '';
      };
      reader.readAsDataURL(file);
    });
  }

(async () => {
    try {
        const initialParams = new URLSearchParams(window.location.search);
        const initialSearchQuery = (initialParams.get('q') || '').trim();
        const focusMode = initialParams.get('focus') === '1';
        const endpointParams = new URLSearchParams();
        if (focusMode && initialSearchQuery) {
            endpointParams.set('q', initialSearchQuery);
            endpointParams.set('status', 'approved');
            endpointParams.set('limit', '80');
        }
        const endpoint = endpointParams.toString()
            ? `/api/plants?${endpointParams.toString()}`
            : '/api/plants';
        const plants = await jsonFetch(endpoint);
        if (!plants || !plants.length) {
            if (statusEl) statusEl.textContent = 'No plants recorded yet.';
            return;
        }

        // build cards and attach a normalized search index on each card
        plants.forEach((p) => {
            const plantData = buildPlantDataFromRecord(p);
            const common = plantData.common;
            const latin = plantData.latin;
            const family = plantData.family;
            const category = plantData.category;
            const lifecycle = plantData.lifecycle;
            const image = plantData.image;
            const nativeRange = plantData.nativeRange;
            const height = plantData.height;
            const spread = plantData.spread;
            const sun = plantData.sun;
            const soil = plantData.soil;
            const water = plantData.water;
            const hardiness = plantData.hardiness;
            const seedNotes = plantData.seedNotes;
            const strat = plantData.strat;
            const propagation = plantData.propagation;
            const usesEdible = plantData.usesEdible;
            const usesMedicinal = plantData.usesMedicinal;
            const usesOther = plantData.usesOther;
            const storageNotes = plantData.storageNotes;
            const recipes = plantData.recipes;
            const pollinators = plantData.pollinators;
            const wildlife = plantData.wildlife;
            const nativeNotes = plantData.nativeNotes;
      const harvestNotes = plantData.harvestNotes;
      const shortDesc = plantData.shortDesc;
      const funFacts = plantData.funFacts;
            const stock = plantData.stock;
      const reviewStatus = plantData.review_status;
      const isPending = (reviewStatus || '').toLowerCase() !== 'approved';
      const plantId = plantData.id;

            const metaItems = [];
            if (category) metaItems.push(category);
            if (lifecycle) metaItems.push(lifecycle);
            if (stock !== '') metaItems.push(`Approx. stock: ${stock}`);
            if (nativeRange) metaItems.push(`Native: ${nativeRange}`);

            const sizeItems = [height, spread].filter(Boolean).join(' / ');
            if (sizeItems) metaItems.push(`Size: ${sizeItems}`);

            const envItems = [sun, soil, water].filter(Boolean).join('     ');
            if (envItems) metaItems.push(envItems);

            if (hardiness) metaItems.push(`Hardiness: ${hardiness}`);

            const uses = [usesEdible, usesMedicinal, usesOther].filter(Boolean).join('; ');
            if (uses) metaItems.push(`Uses: ${uses}`);

            if (pollinators) metaItems.push(`Pollinators: ${pollinators}`);

//      summary-only card content
const cardChildren = [];
if (image) {
  const img = createEl('img', {
    src: image,
    alt: common || latin || 'plant image',
    class: 'plant-thumb',
    loading: 'lazy',
    decoding: 'async',
    fetchpriority: 'low'
  });
  cardChildren.push(img);
}

cardChildren.push(
  createEl('h3', { text: common || 'Unnamed plant' })
);

// latin + family inline
if (latin || family) {
  const lf = createEl('div', { class: 'latin-family' });
  if (latin) lf.appendChild(createEl('span', { class: 'latin muted', text: latin }));
  if (family) lf.appendChild(createEl('span', { class: 'family muted', text: family }));
  cardChildren.push(lf);
}

if (shortDesc) {
  cardChildren.push(createEl('p', { text: shortDesc }));
}

  if (isPending) {
  const flag = createEl('span', { class: 'review-flag review-flag--pending', text: 'Pending Approval', title: reviewMessage });
  flag.addEventListener('click', (evt) => {
    evt.stopPropagation();
    window.lnfUi.alert({
      title: 'Pending approval',
      message: reviewMessage
    });
  });
  cardChildren.push(createEl('div', { class: 'review-flag-wrap' }, flag));
}

//      no metaItems rendered in the card anymore
// we still keep metaItems for search + modal, just not in the grid

          
            

            const cardClass = isPending ? 'card plant-card plant-card--pending' : 'card plant-card';
            const card = createEl('article', { class: cardClass }, cardChildren);
            card.dataset.originalIndex = String(plantList.children.length);

            //      full data for modal
              const modalSeed = {
                ...plantData,
                review_status: reviewStatus
              };

            // Make entire card open modal (except QR controls)
            card.addEventListener('click', (e) => {
                if (e.target.closest('.card-actions')) return; // don't trigger when clicking QR buttons
                openPlantModalWithDetail(modalSeed);
            });
            card.addEventListener('keypress', (e) => {
                if (e.key === 'Enter' || e.key === ' ') {
                    if (e.target.closest('.card-actions')) return;
                    e.preventDefault();
                    openPlantModalWithDetail(modalSeed);
                }
            });

            // Attach plant name/id metadata for QR + search/deep-linking
            const plantName = common || latin || '';
            card.dataset.plantName = plantName;
            card.dataset.plantNameNorm = normalizeText(plantName);
            card.dataset.plantCommonNorm = normalizeText(common);
            card.dataset.plantLatinNorm = normalizeText(latin);
            card.dataset.plantId = plantId ? String(plantId) : '';
            card.dataset.familySort = normalizeText(family);
            card.dataset.categorySort = normalizeText(category);
            card.dataset.nativeRangeSort = normalizeText(nativeRange);
            card.dataset.familyLabel = family || 'Unspecified';
            card.dataset.categoryLabel = category || 'Unspecified';
            card.dataset.nativeRangeLabel = nativeRange || 'Unspecified';

            // Build a searchable string that covers main fields
            const indexParts = [
                common,
                latin,
                family,
                category,
                lifecycle,
                shortDesc,
                metaItems.join(' '),
                propagation,
                seedNotes,
                strat,
                harvestNotes,
                plantData.pruningNotes,
                funFacts,
                nativeNotes,
                wildlife,
                pollinators
            ];
            card.dataset.search = normalizeText(indexParts.filter(Boolean).join(' '));

      // Add QR UI actions container (unchanged)
      const actions = createEl('div', { class: 'card-actions' });
      actions.innerHTML = `
        <button class="check-stock button ghost" type="button">Check Stock</button>
        <button class="qr-toggle button">Show QR</button>
        <a class="qr-download button" style="display:none;" download>Download QR</a>
        <button class="qr-print button" style="display:none;">Print QR</button>
        <div class="qr-container" aria-hidden="true" style="display:none;"></div>
      `;
            card.appendChild(actions);

      plantList.appendChild(card);

      // QR handling (your original block, unchanged)
      (function setupQr(cardEl, plantObj) {
        const checkStockBtn = cardEl.querySelector('.check-stock');
        const qrToggle = cardEl.querySelector('.qr-toggle');
        const qrContainer = cardEl.querySelector('.qr-container');
        const qrDownload = cardEl.querySelector('.qr-download');
        const qrPrintBtn = cardEl.querySelector('.qr-print');
        let cachedQrDataUrl = null;

                function plantUrlFor(obj) {
                    const name = obj && (obj.common_name || obj.commonName || obj.common) || '';
                    const base = new URL('plants.html', location.href).href.split('?')[0].split('#')[0];
                    return `${base}?plant=${encodeURIComponent(name)}`;
                }

                async function ensureQr() {
                    if (cachedQrDataUrl) return cachedQrDataUrl;
                    const temp = document.createElement('div');
                    temp.style.position = 'fixed';
                    temp.style.left = '-9999px';
                    temp.style.width = '1px';
                    temp.style.height = '1px';
                    document.body.appendChild(temp);
                    return new Promise((resolve) => {
                        /* global QRCode */
                        new QRCode(temp, { text: plantUrlFor(plantObj), width: 300, height: 300, correctLevel: QRCode.CorrectLevel.H });
                        setTimeout(() => {
                            const el = temp.querySelector('img') || temp.querySelector('canvas');
                            if (el) {
                                if (el.tagName.toLowerCase() === 'img') cachedQrDataUrl = el.src;
                                else cachedQrDataUrl = el.toDataURL && el.toDataURL('image/png');
                            }
                            document.body.removeChild(temp);
                            resolve(cachedQrDataUrl);
                        }, 80);
                    });
                }

                qrToggle && qrToggle.addEventListener('click', async () => {
                    const showing = qrContainer.style.display !== 'none' && qrContainer.style.display !== '';
                    if (!showing) {
                        if (!cachedQrDataUrl) {
                            qrContainer.innerHTML = '';
                            new QRCode(qrContainer, { text: plantUrlFor(plantObj), width: 240, height: 240, correctLevel: QRCode.CorrectLevel.H });
                            setTimeout(() => {
                                const el = qrContainer.querySelector('img') || qrContainer.querySelector('canvas');
                                if (el) {
                                    if (el.tagName.toLowerCase() === 'img') cachedQrDataUrl = el.src;
                                    else cachedQrDataUrl = el.toDataURL && el.toDataURL('image/png');
                                    if (cachedQrDataUrl) {
                                        qrDownload.href = cachedQrDataUrl;
                                        qrDownload.style.display = '';
                                        qrDownload.setAttribute('download', (plantObj.slug || plantObj.id || plantObj.common_name || 'plant') + '-qr.png');
                                        qrPrintBtn.style.display = '';
                                    }
                                }
                            }, 80);
                        }
                        qrContainer.style.display = '';
                        qrContainer.setAttribute('aria-hidden', 'false');
                        qrToggle.textContent = 'Hide QR';
                    } else {
                        qrContainer.style.display = 'none';
                        qrContainer.setAttribute('aria-hidden', 'true');
                        qrToggle.textContent = 'Show QR';
                    }
                });

                qrPrintBtn && qrPrintBtn.addEventListener('click', async () => {
                    const dataUrl = await ensureQr();
                    const w = window.open('', '_blank', 'width=420,height=640');
                    const html = `
                        <html>
                        <head>
                            <meta charset="utf-8" />
                            <title>Print QR - ${escapeHtml(plantObj.common_name || plantObj.common || '')}</title>
                            <style>${FONT_FACE_CSS} body{font-family:${FONT_FAMILY};padding:20px;text-align:center} .qr{width:300px;height:300px;margin:0 auto} .name{margin-top:12px;font-weight:600}</style>
                        </head>
                        <body>
                            <div class="qr"><img src="${dataUrl || ''}" style="width:300px;height:300px" alt="QR code"></div>
                            <div class="name">${escapeHtml(plantObj.common_name || plantObj.common || '')}</div>
                            <script>window.addEventListener('load',()=>{(document.fonts?document.fonts.ready:Promise.resolve()).then(()=>window.print());},{once:true});</script>
                        </body>
                        </html>
                    `;
                    w.document.write(html);
                    w.document.close();
                });

	        cardEl._getQrDataUrl = ensureQr;
	        checkStockBtn && checkStockBtn.addEventListener('click', (evt) => {
	          evt.stopPropagation();
	          handleStockCheck(plantObj);
	        });
	      })(card, p);
    });

        //      Search wiring     normalized, debounced, and URL-syncing (unchanged)
  const searchInput = $('#plantSearch');
  const sortSelect = $('#plantSort');
  const cards = Array.from(plantList.querySelectorAll('.plant-card'));
  let plantRenderLimit = 24;
  const plantRenderStep = 20;
  const plantSentinel = document.createElement('div');
  plantSentinel.id = 'plantLoadMore';
  plantSentinel.className = 'scroll-sentinel';
  plantList.after(plantSentinel);
  cards.forEach((c) => { c.dataset.matched = '1'; });

        const baseSort = (a, b) => Number(a.dataset.originalIndex || 0) - Number(b.dataset.originalIndex || 0);
        const nameSort = (a, b) => (a.dataset.plantNameNorm || '').localeCompare(b.dataset.plantNameNorm || '') || baseSort(a, b);
        const buildSorter = (key) => (a, b) => {
            const va = a.dataset[key] || '';
            const vb = b.dataset[key] || '';
            if (!va && !vb) return baseSort(a, b);
            if (!va) return 1;
            if (!vb) return -1;
            return va.localeCompare(vb) || nameSort(a, b);
        };

        const sorters = {
            default: baseSort,
            family: buildSorter('familySort'),
            category: buildSorter('categorySort'),
            nativeRange: buildSorter('nativeRangeSort')
        };

        let currentSort = (sortSelect && sortSelect.value) || 'default';

        function refreshGroupVisibility() {
            const headers = plantList.querySelectorAll('.plant-group-header');
            headers.forEach((header) => {
                const groupKey = header.dataset.groupKey || '';
                const hasVisible = Array.from(plantList.querySelectorAll(`.plant-card[data-group-key="${groupKey}"]`))
                    .some((c) => c.style.display !== 'none');
                header.style.display = hasVisible ? '' : 'none';
            });
        }

        function applySort(value) {
            const sortKey = sorters[value] ? value : 'default';
            currentSort = sortKey;
            const sorted = cards.slice().sort(sorters[sortKey]);

            // remove old headers
    plantList.querySelectorAll('.plant-group-header').forEach((el) => el.remove());

    const frag = document.createDocumentFragment();
    if (sortKey === 'default') {
      sorted.forEach((card) => {
        card.dataset.groupKey = '';
        frag.appendChild(card);
      });
      plantList.appendChild(frag);
      applyRenderWindow(false);
      return;
    }

            const labelKeyMap = {
                family: 'familyLabel',
                category: 'categoryLabel',
                nativeRange: 'nativeRangeLabel'
            };
            const labelKey = labelKeyMap[sortKey];
            let lastGroup = null;

            sorted.forEach((card) => {
                const label = card.dataset[labelKey] || 'Unspecified';
                const groupKey = (card.dataset[sortKey + 'Sort'] || '').trim() || 'unspecified';
                if (groupKey !== lastGroup) {
                    const header = createEl('div', { class: 'plant-group-header', text: label });
                    header.dataset.groupKey = groupKey;
                    frag.appendChild(header);
                    lastGroup = groupKey;
                }
                card.dataset.groupKey = groupKey;
                frag.appendChild(card);
            });

    plantList.appendChild(frag);
    applyRenderWindow(false);
    refreshGroupVisibility();
  }

    function applyRenderWindow(resetLimit = false) {
      if (resetLimit) plantRenderLimit = 24;
      const all = Array.from(plantList.querySelectorAll('.plant-card'));
      let totalMatches = 0;
      let shown = 0;
      all.forEach((card) => {
        const matched = card.dataset.matched !== '0';
        if (matched) totalMatches += 1;
      });
      all.forEach((card) => {
        const matched = card.dataset.matched !== '0';
        if (!matched) {
          card.style.display = 'none';
          return;
        }
        if (shown < plantRenderLimit) {
          card.style.display = '';
          shown += 1;
        } else {
          card.style.display = 'none';
        }
      });
      const hasMore = shown < totalMatches;
      if (plantSentinel) plantSentinel.style.display = hasMore ? '' : 'none';
    }

    if (plantSentinel && 'IntersectionObserver' in window) {
      const observer = new IntersectionObserver((entries) => {
        if (entries.some((e) => e.isIntersecting)) {
          plantRenderLimit += plantRenderStep;
          applyRenderWindow(false);
        }
      }, { rootMargin: '220px' });
      observer.observe(plantSentinel);
    }

    function updateStatus(matches) {
      if (!statusEl) return;
      if (matches === 0) statusEl.textContent = 'No plants match that search.';
      else statusEl.textContent = '';
    }

    function filterPlantsRaw(term) {
      const q = normalizeText(term || '');
      let matches = 0;
      for (const card of cards) {
        const isMatch = !q || (card.dataset.search || '').includes(q);
        card.dataset.matched = isMatch ? '1' : '0';
        if (isMatch) matches++;
      }
      applyRenderWindow(true);
      updateStatus(matches);
      refreshGroupVisibility();
    }

        const filterPlants = debounce(filterPlantsRaw, 200);

        if (searchInput) {
            const params = new URLSearchParams(window.location.search);
            const initial = params.get('q') || '';

            if (initial) {
                searchInput.value = initial;
                filterPlantsRaw(initial);
            }

            searchInput.addEventListener('input', (e) => {
                const term = e.target.value || '';
                filterPlants(term);

                const url = new URL(window.location.href);
                if (term.trim()) url.searchParams.set('q', term.trim());
                else url.searchParams.delete('q');
                window.history.replaceState({}, '', url.toString());
            });
        }

        if (sortSelect) {
            const params = new URLSearchParams(window.location.search);
            const initialSort = params.get('sort');
            if (initialSort && sorters[initialSort]) {
                sortSelect.value = initialSort;
                currentSort = initialSort;
            }

            applySort(currentSort);

            sortSelect.addEventListener('change', (e) => {
                const selected = e.target.value;
                applySort(selected);
                const url = new URL(window.location.href);
                if (selected && selected !== 'default') url.searchParams.set('sort', selected);
                else url.searchParams.delete('sort');
                window.history.replaceState({}, '', url.toString());
            });
        } else {
            applySort('default');
        }

    (function handlePlantParam() {
      const params = new URLSearchParams(window.location.search);
      const targetId = String(params.get('plant_id') || '').trim();
      const targetName = params.get('plant') || '';
      const norm = normalizeText(targetName);
      const target = cards.find((card) => {
        if (targetId && String(card.dataset.plantId || '').trim() === targetId) return true;
        if (!norm) return false;
        return card.dataset.plantNameNorm === norm
          || card.dataset.plantCommonNorm === norm
          || card.dataset.plantLatinNorm === norm;
      });
      if (target) {
        plantRenderLimit = cards.length;
        applyRenderWindow(false);
        target.classList.add('highlighted-plant');
        target.scrollIntoView({ behavior: 'smooth', block: 'center' });
        setTimeout(() => target.classList.remove('highlighted-plant'), 8000);
      }
    })();

        // QR sheet printing (unchanged)
        const printQrSheetBtn = document.getElementById('printQrSheet');
        if (printQrSheetBtn) {
            printQrSheetBtn.addEventListener('click', async () => {
                const visible = cards.filter(c => c.style.display !== 'none');
                if (!visible.length) {
                  await window.lnfUi.alert({
                    title: 'QR Sheet',
                    message: 'No plants visible to print.'
                  });
                  return;
                }
                const batch = visible.slice(0, 200);
                const items = [];
                for (const c of batch) {
                    const name = c.dataset.plantName || '';
                    try {
                        const dataUrl = await (c._getQrDataUrl ? c._getQrDataUrl() : Promise.resolve(null));
                        items.push({ name, dataUrl });
                    } catch (e) {
                        console.error('QR gen failed for', name, e);
                    }
                }
                const cells = items.map(it => `
                    <div class="cell">
                        <img src="${it.dataUrl || ''}" style="width:200px;height:200px" alt="QR" />
                        <div class="label">${escapeHtml(it.name)}</div>
                    </div>
                `).join('');
                const html = `
                    <html>
                    <head>
                        <meta charset="utf-8" />
                        <title>QR Sheet</title>
                        <style>
                            ${FONT_FACE_CSS}
                            body{font-family:${FONT_FAMILY};padding:20px}
                            .grid{display:flex;flex-wrap:wrap;gap:12px}
                            .cell{width:30%;text-align:center;page-break-inside:avoid;margin-bottom:16px}
                            .label{margin-top:6px;font-size:14px}
                            @media print{ .no-print{display:none} }
                        </style>
                    </head>
                    <body>
                        <div class="grid">${cells}</div>
                        <script>window.addEventListener('load',()=>{(document.fonts?document.fonts.ready:Promise.resolve()).then(()=>window.print());},{once:true});</script>
                    </body>
                    </html>
                `;
                const w = window.open('', '_blank');
                w.document.write(html); w.document.close();
            });
        }

  } catch (err) {
    console.error(err);
    if (statusEl) statusEl.textContent = 'Failed to load plants.';
  }
})();
});
